var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataindexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_6573)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_272_6573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 5.33301H15.9997L18.6663 7.99967H25.333C26.0403 7.99967 26.7185 8.28063 27.2186 8.78072C27.7187 9.28082 27.9997 9.9591 27.9997 10.6663V19.9997C27.9997 20.7069 27.7187 21.3852 27.2186 21.8853C26.7185 22.3854 26.0403 22.6663 25.333 22.6663H11.9997C11.2924 22.6663 10.6142 22.3854 10.1141 21.8853C9.61396 21.3852 9.33301 20.7069 9.33301 19.9997V7.99967C9.33301 7.29243 9.61396 6.61415 10.1141 6.11406C10.6142 5.61396 11.2924 5.33301 11.9997 5.33301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 22.667V25.3337C22.6667 26.0409 22.3857 26.7192 21.8856 27.2193C21.3855 27.7194 20.7072 28.0003 20 28.0003H6.66667C5.95942 28.0003 5.28115 27.7194 4.78105 27.2193C4.28095 26.7192 4 26.0409 4 25.3337V13.3337C4 12.6264 4.28095 11.9481 4.78105 11.448C5.28115 10.9479 5.95942 10.667 6.66667 10.667H9.33333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_6573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_272_6573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataindexIcon);
export default __webpack_public_path__ + "static/media/dataindex-icon.fe7c7120c17738977891210e5f9b2425.svg";
export { ForwardRef as ReactComponent };